import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { VehicleColorPage } from './vehicle-color.page';

const routes: Routes = [
  {
    path: '',
    component: VehicleColorPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VehicleColorPageRoutingModule {}
